import {
  Button,
  Grid,
  TextField,
  Stack,
  Tab,
  Tabs,
  Box,
  Typography,
  Backdrop,
  CircularProgress,
  FormControl,
  // InputLabel,
  Select,
  MenuItem,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import MappingTable from './MappingTable';
import TerminalList from './TerminalList';
// import { useNavigate } from 'react-router';
import { TerminalMappingApiView, TerminalMappingApiViewList } from 'API/Services';
import PropTypes from 'prop-types';
import { FiBankList } from 'API/Reports';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Index = () => {
  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    };
  }

  // const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [TotalCount, setTotalCount] = useState('');
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };
  const [IsLoading, setIsLoading] = useState(false);
  const [BankList, setBankList] = useState(null);
  const [ResData, setResData] = useState('');
  const [TryData, setTryData] = useState('');
  const [rowsPerPageTer, setRowsPerPageTer] = useState(10);
  const [pageTer, setPageTer] = useState(0);
  const [TotalCountTer, setTotalCountTer] = useState('');
  const handleChangePageTer = (event, newPage) => {
    setPageTer(newPage);
  };

  const handleChangeRowsPerPageTer = (event) => {
    setRowsPerPageTer(event.target.value);
    setPageTer(0);
  };
  // Search States
  const [searchAgentName, setSearchAgentName] = useState('');
  const [searchAgentCode, setSearchAgentCode] = useState('');
  const [searchBankName, setSearchBankName] = useState('');

  const handleClear = () => {
    setSearchBankName('');
    setSearchAgentCode('');
    setSearchAgentName('');
  };
  const handleInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z\s]/g, '');
  };
  const handleCodeInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z0-9]/g, '');
  };
  useEffect(() => {
    if (value === 0) {
      setResData([]);
      TerminalMappingApiView(
        setIsLoading,
        searchBankName,
        searchAgentCode,
        searchAgentName,
        page + 1,
        rowsPerPage,
        setResData,
        setTotalCount
      );
    }
  }, [value, page, rowsPerPage, searchBankName, searchAgentCode, searchAgentName]);

  useEffect(() => {
    if (value === 1) {
      setTryData([]);
      TerminalMappingApiViewList(
        setIsLoading,
        searchBankName,
        searchAgentCode,
        searchAgentName,
        pageTer + 1,
        rowsPerPageTer,
        setTryData,
        setTotalCountTer
      );
    }
  }, [value, pageTer, rowsPerPageTer, searchBankName, searchAgentCode, searchAgentName]);
  useEffect(() => {
    FiBankList(setBankList);
  }, []);
  return (
    <Grid container>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={IsLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid item xl={12} width="100%">
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
            <Typography variant="h4">Terminal Mapping</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {/* <MainCard title="Terminal Mapping"> */}
            <Grid container spacing={2} alignItems="center">
              <Grid item xl={3} lg={3} md={3} sm={6} xs={6}>
                <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                  Agent Name
                </Typography>
                <TextField
                  // label="Agent name"
                  size="small"
                  fullWidth
                  onInput={handleInput}
                  value={searchAgentName}
                  onChange={(e) => setSearchAgentName(e.target.value)}
                />
              </Grid>
              <Grid item xl={3} lg={3} md={3} sm={6} xs={6}>
                <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                  Agent Code
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  // label="Agent Code"
                  onInput={handleCodeInput}
                  value={searchAgentCode}
                  onChange={(e) => setSearchAgentCode(e.target.value.trim())}
                />
              </Grid>
              <Grid item xl={3} lg={3} md={3} sm={6} xs={6}>
                <FormControl fullWidth>
                  {/* <InputLabel id="demo-simple-select-label">Bank name</InputLabel> */}
                  <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                    Bank Name
                  </Typography>
                  <Select
                    // label="Bank name"
                    size="small"
                    fullWidth
                    onInput={handleInput}
                    value={searchBankName ? searchBankName : 'select'}
                    onChange={(e) => setSearchBankName(e.target.value)}
                  >
                    <MenuItem value={'select'} disabled>
                      Select
                    </MenuItem>
                    {BankList &&
                      BankList.map((bank, index) => (
                        <MenuItem value={bank.Bankname} key={index}>
                          {bank.Full_Bank_Name.toUpperCase()}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid spacing={2} item xl={3} mt={3}>
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={!searchBankName && !searchAgentCode && !searchAgentName}
                  sx={{
                    backgroundColor: '#592375',
                    color: '#FFFFFF',
                    borderRadius: '6px',
                    '&:hover': {
                      backgroundColor: '#592375'
                    }
                  }}
                  size="small"
                  onClick={() => handleClear()}
                >
                  Clear
                </Button>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {/* </MainCard> */}
      </Grid>
      <Grid item xl={12} width="100%" mt={1}>
        <MainCard sx={{ width: '100%', overflow: 'scroll' }}>
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleTabChange} aria-label="basic tabs example">
                <Tab label="Pending for Terminal Id creation" {...a11yProps(0)} />
                <Tab label="List of Terminal Id" {...a11yProps(1)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              {ResData && ResData.length ? (
                <MappingTable
                  ResData={ResData}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  handleChangePage={handleChangePage}
                  TotalCount={TotalCount}
                />
              ) : (
                <Stack justifyContent="center" alignItems="center">
                  {/* <CircularProgress /> */}
                  <Typography mt={1} variant="h5">
                    No data found
                  </Typography>
                </Stack>
              )}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              {TryData && TryData.length ? (
                <TerminalList
                  TryData={TryData}
                  rowsPerPage={rowsPerPageTer}
                  page={pageTer}
                  handleChangeRowsPerPage={handleChangeRowsPerPageTer}
                  handleChangePage={handleChangePageTer}
                  TotalCountTer={TotalCountTer}
                />
              ) : (
                <Stack justifyContent="center" alignItems="center">
                  {/* <CircularProgress /> */}
                  <Typography mt={1} variant="h5">
                    No data found
                  </Typography>
                </Stack>
              )}
            </CustomTabPanel>
          </Box>
        </MainCard>
      </Grid>
    </Grid>
  );
};

export default Index;
